import { createContext } from 'react';
const ProjectTypeContext = createContext('wecourier');
export { ProjectTypeContext }